import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import React, {useState} from "react";
import "./TrailExpired.css"
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Enums from "../Enums";
import {showSaveSuccessMessage} from "../../toastUtils";

function TrailExpired() {
    const [value, setValue] = React.useState('annual');
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    }

    const openDeleteModal = () => {
        setShowDeleteModal(true);
    }

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
    }

    const handleDataDelete = () => {
        setShowDeleteModal(false);
        showSaveSuccessMessage(`We have received your request and will delete your data`);
    }

    return (
        <section>
            <Grid container direction={"row"} data-testid='trail-expired' className="trail-expired-main-container">
                <Grid item xs={12}>
                    <Box className="container">
                        <h1>Your trial period has ended</h1>

                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="391" height="18" viewBox="0 0 391 18"
                                 fill="none">
                                <path
                                    d="M390.5 7.69279C388.521 7.46128 386.702 7.40032 384.718 7.33381C382.733 7.26731 380.92 7.04134 378.941 6.80983C374.653 6.33573 370.536 5.70216 366.248 5.22806C358.168 4.29647 349.922 3.35935 341.825 2.92278C334.394 2.34338 326.793 1.92344 319.352 1.67405C317.367 1.60754 315.383 1.54103 313.564 1.48007C306.116 1.39568 298.675 1.14629 291.228 1.0619C273.847 0.974999 256.3 0.882553 238.908 1.12566C221.847 1.37985 204.785 1.63404 187.883 2.05878C179.598 2.27669 171.147 2.48906 162.861 2.70697C153.737 3.22718 144.625 3.41738 135.672 3.77813C116.934 4.63692 98.3672 5.33625 79.6291 6.19504C63.3773 6.97195 47.2737 8.24943 31.153 10.0219C20.843 11.3284 10.362 12.7943 0.0462851 14.2657C11.7589 15.4842 23.654 16.2133 35.5549 16.7773C43.3272 17.0378 51.1052 17.1332 58.7179 17.2232C63.6847 17.2244 68.6572 17.0607 73.795 16.9025C76.9427 16.8428 79.9308 16.6125 82.9188 16.3823C91.0505 15.8288 99.3417 15.4459 107.473 14.8924C116.928 14.3833 126.223 13.7036 135.677 13.1945C145.297 12.6909 155.083 12.1929 164.703 11.6893C173.325 11.3175 182.112 10.9512 190.899 10.5849C199.356 10.2075 207.972 10.0007 216.423 9.78831C225.04 9.58148 233.491 9.36911 242.107 9.16228C250.889 8.961 259.493 9.08418 268.269 9.0479C284.168 8.91992 300.049 9.28696 316.095 9.65953C325.025 9.95881 333.801 9.92253 342.742 9.89179C351.518 9.85551 360.294 9.81923 368.911 9.6124C372.389 9.56378 376.033 9.5207 379.517 9.30707C381.176 9.19749 383.001 9.09345 384.666 8.81886C386.166 8.53873 387.671 8.09359 389.166 7.97846C389.667 7.83009 390.004 7.67616 390.5 7.69279Z"
                                    fill="#FF6600"/>
                            </svg>
                        </div>
                    </Box>

                    <Box className="trail-expired-container">
                        <Box className="container">
                            <Grid container direction={"row"}>
                                <Grid xs={12}>
                                    <h2>
                                        Benefits
                                    </h2>
                                </Grid>
                            </Grid>

                            <Grid container direction={"row"}>
                                {/* -- Benefits --*/}
                                <Grid item xs={12} sm={12} md={6} lg={7} xl={7}>
                                    <div className="available-features" data-testid={"available-features"}>
                                        <FormControlLabel control=
                                                              {
                                                                  <Checkbox defaultChecked disabled
                                                                            className={"features-item"}/>
                                                              }
                                                          label="We improve hiring efficiency and effectiveness while minimising costs."/>

                                        <FormControlLabel control=
                                                              {
                                                                  <Checkbox defaultChecked disabled
                                                                            className={"features-item"}/>
                                                              }
                                                          label="Boost your employer brand with an awesome applicant user experience."/>

                                        <FormControlLabel control=
                                                              {
                                                                  <Checkbox defaultChecked disabled
                                                                            className={"features-item"}/>
                                                              }
                                                          label="Manage all your applications and job positions from one place."/>

                                        <FormControlLabel control=
                                                              {
                                                                  <Checkbox defaultChecked disabled
                                                                            className={"features-item"}/>
                                                              }
                                                          label="Securely store candidate interactions and information all in one place."/>

                                        <FormControlLabel control=
                                                              {
                                                                  <Checkbox disabled
                                                                            className={"features-item"}/>
                                                              }
                                                          label="AI driven job matching (Coming)"
                                                          className={"coming-soon"}/>

                                        <FormControlLabel control=
                                                              {
                                                                  <Checkbox disabled
                                                                            className={"features-item"}/>
                                                              }
                                                          label="Analytics throughout the recruitment process (Coming)"
                                                          className={"coming-soon"}/>

                                        <FormControlLabel control=
                                                              {
                                                                  <Checkbox disabled
                                                                            className={"features-item"}/>
                                                              }
                                                          label="Intelligent skills testing for the candidate (Coming)"
                                                          className={"coming-soon"}/>
                                    </div>
                                </Grid>

                                {/* -- Packages -- */}
                                <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                                    <Box className={"package-options-main-container"}>
                                        <TabContext value={value}>
                                            <Box className={"package-options-container"}>
                                                <TabList onChange={handleChange} centered>
                                                    <Tab label="Annual- 20% Off" value="annual"/>
                                                    <Tab label="Monthly" value="monthly"/>
                                                </TabList>
                                            </Box>

                                            <TabPanel value="annual">
                                                <div className={"package-price-per-month"}>
                                                    R360 <span>/user per month</span>
                                                </div>

                                                <div className={"package-price-for-year"}>
                                                    R 4 320 for the year
                                                </div>

                                                <div className={"package-description"}>
                                                    This package is suitable for businesses who hire consistently
                                                    throughout the year.
                                                </div>

                                                <div className={"package-call-to-action"}>
                                                    <Button className={"btn btn-primary-custom w-100"}>
                                                        Subscribe
                                                    </Button>

                                                    <Button className={"btn btn-outline-custom w-100"}
                                                            onClick={openDeleteModal}>
                                                        Delete my data
                                                    </Button>
                                                </div>
                                            </TabPanel>

                                            <TabPanel value="monthly">
                                                <div className={"package-price-per-month"}>
                                                    R400 <span>/user per month</span>
                                                </div>

                                                <div className={"package-price-for-year"}>
                                                    R 4 800 for the year
                                                </div>

                                                <div className={"package-description"}>
                                                    This package is suitable for businesses who hire consistently
                                                    throughout the year.
                                                </div>

                                                <div className={"package-call-to-action"}>
                                                    <Button className={"btn btn-primary-custom w-100"}>
                                                        Subscribe
                                                    </Button>

                                                    <Button className={"btn btn-outline-custom w-100"}
                                                            onClick={openDeleteModal}>
                                                        Delete my data
                                                    </Button>
                                                </div>
                                            </TabPanel>
                                        </TabContext>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>

                <Modal open={showDeleteModal}
                       data-testid={"delete-subscription-data"}>
                    <Box sx={Enums.modalStyle}>
                        <h3>
                            Cancel Confirmation
                        </h3>
                        <Grid container direction={"row"} alignItems={"flex-end"} padding={2} spacing={2}>
                            <Grid item xs={12}>
                                <body-4>
                                    Are you sure you want to delete your data?
                                </body-4>
                            </Grid>

                            <Grid item xs={12} className={"text-end"}>
                                <Button data-testid={"cancel-delete"}
                                        onClick={closeDeleteModal}
                                        className={"btn btn-secondary-custom me-3"}>Cancel</Button>

                                <Button data-testid={"delete-data"} className={"btn btn-primary-custom"}
                                        onClick={handleDataDelete}>Delete</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>
            </Grid>
        </section>
    )
}

export default TrailExpired;